import React from 'react';

const IconRoute = ({ onClick }) => {
	return (
		<div className='IconRoute' onClick={onClick}>
			<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
				<path d='M9 20L3 17V4L9 7M9 20L15 17M9 20V7M15 17L21 20V7L15 4M15 17V4M9 7L15 4' stroke='#344054' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
			</svg>
		</div>
	);
};

export default IconRoute;
